import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  palette,
  spaceXLarge,
  spaceMin,
  fontFamilies,
  fontWeights,
  breakpoints,
}: Theme) => ({
  root: {
    padding: `2.5rem 0 ${spaceXLarge}`,
  },
  contentStyles: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2.5rem',
  },
  title: {
    margin: 0,
    fontFamily: fontFamilies.secondary,
    fontSize: '2.375rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.2,
    textAlign: 'center',
    [breakpoints.up('md')]: {
      fontSize: '4.5rem',
    },
  },
  titleFirst: {
    display: 'block',
    color: palette.primary.dark,
  },
  titleSecond: {
    display: 'block',
    color: palette.primary.main,
  },
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spaceMin,
  },
  logo: {
    height: '3rem',
    width: 'auto',
    maxWidth: '100%',
    objectFit: 'contain',
  },
  content: {
    maxWidth: '54.1rem',
    width: '100%',
    margin: 0,
    fontSize: '1.185rem',
    textAlign: 'center',
  },
}));
